export default __webpack_public_path__ + "static/media/jh_resume.83d3ee57.pdf";